import { POINTS_PER_DOLLAR } from '@nandosaus/constants';
import { formatPointsDisplay } from '@nandosaus/state-management/lib/util/formatter';
import PropTypes from 'prop-types';

import { Box, Flex } from '../grid';
import { Button } from '../button/new';
import { P } from '../typography/new';
import { PointsQuantityPicker } from '../points-quantity-picker';

const PointsEditSection = ({ amount, maxAmount, onChange, onConfirm }) => (
  <>
    <Flex flexDirection="column" justifyContent="center" textAlign="center" gap="12px">
      <Flex flexDirection="column" justifyContent="center" textAlign="center" gap="4px">
        <P variant="standard-semi-bold">How much do you want to pay in points?</P>

        <P variant="small" color="grey500">
          {`${formatPointsDisplay(amount * POINTS_PER_DOLLAR)} pts`}
        </P>
      </Flex>

      <PointsQuantityPicker amount={amount} maxAmount={maxAmount} onChange={onChange} />

      {onConfirm && (
        <Box mt="8px">
          <Button variant="secondary" widthType="fit" size="medium" onClick={onConfirm}>
            Let&apos;s do this!
          </Button>
        </Box>
      )}
    </Flex>
  </>
);

PointsEditSection.propTypes = {
  amount: PropTypes.number.isRequired,
  maxAmount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

PointsEditSection.defaultProps = {
  onConfirm: undefined,
};

export { PointsEditSection };
